import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_23opayswai: FaireBrandEntity = {
  token: "b_23opayswai",
  type: "brand",
  name: "Refinery Number One LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/1a6e7d369a0ef8b6b6f35fedbf44cd621e52ce56143aeffb33b6963ff0f2c3b0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/890463747cd0030ddde389f868ee47579a909c5794e2cf75d4ed79c870a36df5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1a6e7d369a0ef8b6b6f35fedbf44cd621e52ce56143aeffb33b6963ff0f2c3b0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/890463747cd0030ddde389f868ee47579a909c5794e2cf75d4ed79c870a36df5.jpeg",
  location: "Bonita Springs, FL, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 338,
  isTopShop: true,
  isInsider: true,
  description:
    "Refinery Number One began as a humble idea around our kitchen table over a decade ago. Today, we're proud to have grown into a vibrant company that blends creativity, quality, and exceptional craftsmanship. Every product we offer is thoughtfully designed by our dedicated in-house design team, capturing unique and inspiring styles that customers adore.\n\nBased in sunny Florida, our experienced team ensures each item meets meticulous quality standards, proudly surpassing industry expectations. At Refinery Number One, your satisfaction is our mission—because we believe the happiest customers are always our best ambassadors.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:01.952Z",
    importedBy: "entity-db-cli",
  },
};
